"use client";

type Tab<T extends string> = {
  label: string;
  value: T;
};

type TabBarProps<T extends string> = {
  tabs: Tab<T>[];
  active: T;
  onChange: (value: T) => void;
  disabled?: boolean;
};

export function TabBar<T extends string>({
  tabs,
  active,
  onChange,
  disabled,
}: TabBarProps<T>) {
  return (
    <div className="w-full min-w-0 overflow-x-auto hide-scrollbar mb-4">
      <div className="relative after:absolute after:h-[4px] after:w-full after:bg-sand-700 after:bottom-0 after:inset-x-0 flex whitespace-nowrap">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            disabled={disabled || tabs.length === 1}
            className={`relative after:z-10 after:absolute after:h-[4px] after:w-full after:bottom-0 after:inset-x-0 font-bold px-3.5 py-2.5 transition-colors ${
              active === tab.value
                ? "after:bg-red-700"
                : "after:bg-sand-700 hover:after:bg-sand-900 text-gray-500 hover:text-black"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
